import { Flex, Heading, Text } from "@chakra-ui/react";
import { tokenize } from "@ui/utils";
import { ProgressBarLocked } from "./progress-bar-locked";
import { ProgressBarUnlocked } from "./progress-bar-unlocked";
import { ProgressStatCardProps } from "./progress-stat-card-props";

export const ProgressStatCard = (props: ProgressStatCardProps) => {
  const {
    title,
    from,
    value,
    caption,
    progressValue,
    isPublic,
    colorScheme,
    ...rest
  } = props;

  return (
    <Flex
      as="dl"
      bgColor="white"
      p="6"
      rounded="lg"
      shadow="md"
      flexDirection="column"
      _hover={{
        transform: "scale(1.05)",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      {...rest}
    >
      <Text
        as="dt"
        color={`${colorScheme || "green"}.500`}
        fontWeight="bold"
        pb={2}
      >
        {tokenize(title)}
      </Text>
      <Heading as="dd" size="lg" lineHeight="shorter" pb={3} fontWeight="bold">
        {value}
      </Heading>
      <Text fontSize={11} color="gray.500" fontWeight="medium" pb={3}>
        {caption}
      </Text>
      {isPublic ? (
        <ProgressBarLocked justifySelf="flex-end" title={title} from={from} />
      ) : (
        <ProgressBarUnlocked
          justifySelf="flex-end"
          title={title}
          progressValue={progressValue}
          caption={caption}
          value={value}
        />
      )}
    </Flex>
  );
};
